import React from "react";
import { Select, MenuItem, FormHelperText } from "@mui/material";
import styled from "styled-components";
import { fonts, Spacing } from "../../config";

interface InputSelectProps {
  label?: string;
  error?: string;
  options: { value: any; label: string }[];
  value?: any;
  onChange?: (value: any) => void;
  onBlur?: () => void;
}

const FieldLabel = styled.p(({ theme }: any) => ({
  fontFamily: fonts.semibold,
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "15px",
  paddingBottom: "8px",
  margin: 0,
  color: theme.palette.text.primary,
  [theme.breakpoints.down("sm")]: {
    paddingBottom: "5px",
  },
}));

const FieldError = styled(FormHelperText)(({ theme }: any) => ({
  color: "red",
  minHeight: Spacing(2.5),
  [theme.breakpoints.down("sm")]: {
    minHeight: Spacing(2),
  },
}));

function InputSelect({
  label,
  error,
  options,
  value,
  onChange,
  onBlur,
}: InputSelectProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <Select
        value={value ?? ""}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={onBlur}
        variant="standard"
        disableUnderline
        fullWidth
        sx={(theme) => ({
          backgroundColor: "#F0F0F0",
          borderRadius: "21px",
          paddingBlock: "14px",
          paddingInline: "20px",
          "& .MuiSelect-select": { padding: 0 },
          "& .MuiSelect-icon": { right: "20px" },
          [theme.breakpoints.down("sm")]: {
            paddingBlock: "10px",
            paddingInline: "15px",
          },
        })}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
      <FieldError>{error ?? " "}</FieldError>
    </div>
  );
}

export default InputSelect;
